import { render, staticRenderFns } from "./workAge.vue?vue&type=template&id=4e0efdc8&scoped=true"
import script from "./workAge.vue?vue&type=script&lang=js"
export * from "./workAge.vue?vue&type=script&lang=js"
import style0 from "./workAge.vue?vue&type=style&index=0&id=4e0efdc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0efdc8",
  null
  
)

export default component.exports